import React, { useState } from "react";
import { HOME_ID } from "./constants";

// Adds a home by its id, as the API takes it: 24 characters, 0-9 and a-f.
// The API has no way yet for the admin account to look homes up by name.
const HomeIdInput = ({ idPrefix, label, exclude = [], onAdd, disabled = false }) => {
  const [value, setValue] = useState("");
  const id = value.trim().toLowerCase();
  const problem = !id
    ? null
    : !HOME_ID.test(id)
    ? "A home id is 24 characters, 0–9 and a–f."
    : exclude.includes(id)
    ? "That home is already in the list."
    : null;

  const submit = (event) => {
    event.preventDefault();
    if (!id || problem || disabled) return;
    onAdd(id);
    setValue("");
  };

  return (
    <form className="hx-adm-picker" onSubmit={submit} noValidate>
      <label className="hx-label" htmlFor={`${idPrefix}-id`}>
        {label}
      </label>
      <div className="hx-adm-inline">
        <input
          id={`${idPrefix}-id`}
          className="hx-input hx-adm-mono"
          placeholder="Home id"
          autoComplete="off"
          spellCheck={false}
          maxLength={40}
          value={value}
          disabled={disabled}
          aria-invalid={Boolean(problem) || undefined}
          aria-describedby={`${idPrefix}-id-note`}
          onChange={(event) => setValue(event.target.value)}
        />
        <button type="submit" className="hx-btn" disabled={disabled || !id || Boolean(problem)}>
          Add
        </button>
      </div>
      <p id={`${idPrefix}-id-note`} className={`hx-adm-note ${problem ? "is-error" : ""}`}>
        {problem ?? "Paste the home's id. Names show once a migration report has listed the home."}
      </p>
    </form>
  );
};

export default HomeIdInput;
